import { AxiosInstance } from 'axios';

import { giftsEndpoings } from '../../utils/constants';
import { DateRange } from '../../utils/constants/dateRange';
import { axios } from '../axiosInstance';

import { GiftsResponse } from './GiftsApi.schema';

class GiftsApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  getGifts = async (userId: number, order: DateRange): Promise<GiftsResponse> =>
    this.#requestInstance.get(giftsEndpoings.giftsId(userId), {
      params: {
        order,
      },
    });
}

export const giftsApi = new GiftsApi(axios);
